var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacheremail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    height: "128px",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    width: "128px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99,92H29c-3.3,0-6-2.7-6-6V41c0-3.3,2.7-6,6-6h70c3.3,0,6,2.7,6,6v45C105,89.3,102.3,92,99,92z M29,37    c-2.2,0-4,1.8-4,4v45c0,2.2,1.8,4,4,4h70c2.2,0,4-1.8,4-4V41c0-2.2-1.8-4-4-4H29z",
    fill: "#0B0059"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,90c-2.2,0-4-1.8-4-4V41c0-2.2,1.8-4,4-4h70c2.2,0,4,1.8,4,4v45c0,2.2-1.8,4-4,4H29z",
    fill: "#FFBC08"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.6,37.4c0.2,0.5,0.4,1.1,0.4,1.6v45c0,2.2-1.8,4-4,4H27c-0.6,0-1.1-0.1-1.6-0.4C26,89,27.4,90,29,90    h70c2.2,0,4-1.8,4-4V41C103,39.4,102,38,100.6,37.4z",
    fill: "#FFD76B"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64,66.2l-0.6-0.4c-38.8-26.2-38.9-27.7-39-28.2l0-0.5l0.3-0.4c1.1-1.1,2.6-1.8,4.2-1.8h70    c1.6,0,3.1,0.6,4.2,1.8l0.3,0.3l0,0.5c-0.1,0.6-0.2,2-39,28.2L64,66.2z M26.9,37.6c3.7,3.3,23.9,17.3,37.1,26.2    c13.2-8.9,33.5-22.9,37.1-26.2c-0.6-0.4-1.4-0.6-2.1-0.6H29C28.2,37,27.5,37.2,26.9,37.6z",
    fill: "#0B0059"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99,92H29c-1.6,0-3.1-0.6-4.2-1.8l-0.3-0.3l0-0.5c0.1-0.6,0.2-2,39-28.2l0.6-0.4l0.6,0.4    c38.8,26.2,38.9,27.7,39,28.2l0,0.5l-0.3,0.4C102.1,91.4,100.6,92,99,92z M26.9,89.4c0.6,0.4,1.4,0.6,2.1,0.6h70    c0.8,0,1.5-0.2,2.1-0.6C97.5,86.1,77.2,72.1,64,63.2C50.8,72.1,30.5,86.1,26.9,89.4z",
    fill: "#0B0059"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64,63.8c-13.2-8.9-33.5-22.9-37.1-26.2c0.6-0.4,1.4-0.6,2.1-0.6h70c0.8,0,1.5,0.2,2.1,0.6    C97.5,40.9,77.2,54.9,64,63.8z",
    fill: "#FFD76B"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,39h70c0.1,0,0.3,0,0.4,0c0.7-0.6,1.3-1.1,1.7-1.4c-0.6-0.4-1.4-0.6-2.1-0.6H29c-0.8,0-1.5,0.2-2.1,0.6    c0.4,0.4,1,0.8,1.7,1.4C28.7,39,28.9,39,29,39z",
    fill: "#FFE49C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacheremail);
export default __webpack_public_path__ + "static/media/teacheremail.d8d7ab692ae6119b9cf5775f9dc747ad.svg";
export { ForwardRef as ReactComponent };